import { inject, Injectable } from '@angular/core';
import { __ } from '@web/birdz-angular';
import { smartWaterKaptaUrl } from 'app/config/constants.config';
import { UserService } from 'app/services/user.service';

@Injectable({
  providedIn: 'root',
})
export class AppsService {
  private userService = inject(UserService);

  getPdsLinkHTML(pdsId: string): string {
    const canAccessPds = this.userService.getUser()?.hasApplication('pds360') ?? false;
    if (!canAccessPds) {
      return '';
    }

    const url: string = this.getPdsUrl(pdsId);
    return `<a 
                title="${__('SEE_ON_PDS360')}"
                href="${url}"
                target="_blank"
                style="margin-left: 3px; color: #12afc6; filter: invert(88%) sepia(21%) saturate(916%) hue-rotate(123deg) brightness(53%) contrast(97%);">
                <img width="21" src="/assets/birdz/svg/icons/app_pds360.svg">
              </a>`;
  }

  getLeaksLinkHTML(contract: string, pdsId: string, noiseLevel?: number | null): string {
    const canAccessLeaks = this.userService.getUser()?.hasApplication('leakslocation') ?? false;
    if (!canAccessLeaks) {
      return '';
    }

    const url: string = this.getLeaksUrl(contract, pdsId, noiseLevel);
    return `<a 
                title="${__('SEE_ON_LEAKSLOCATION')}"
                href="${url}"
                target="_blank"
                style="margin-left: 3px; color: #12afc6; filter: invert(88%) sepia(21%) saturate(916%) hue-rotate(123deg) brightness(53%) contrast(97%);">
                <img width="21" src="/assets/birdz/svg/icons/app_leakslocation.svg">
              </a>`;
  }

  getSmartWaterKaptaLinkHTML(contract: string, pdsId: string): string {
    const canAccessSmartWater = this.userService.getUser()?.hasApplication('smartwater') ?? false;
    if (!canAccessSmartWater) {
      return '';
    }

    const params = new URLSearchParams({ 'refine.code_contrat': contract, 'refine.uniqueid': pdsId });
    return `<a
                title="${__('SEE_ON_SMARTWATER')}"
                href="${smartWaterKaptaUrl}?${params.toString()}"
                target="_blank"
                style="margin-left: 3px; color: #12afc6; filter: invert(88%) sepia(21%) saturate(916%) hue-rotate(123deg) brightness(53%) contrast(97%);">
                <img width="21" src="/assets/birdz/svg/icons/app_smartwater.svg">
              </a>`;
  }

  getPdsUrl(pdsId: string): string {
    const application = this.userService.getUser()?.getApplication('pds360');

    return application ? `${application.url}?pds=${pdsId}` : '#';
  }

  getLeaksUrl(contract: string, pdsId: string, noiseLevel?: number | null): string {
    const application = this.userService.getUser()?.getApplication('leakslocation');

    const params = new URLSearchParams({
      contractId: contract,
      pdsId: pdsId,
    });

    if (noiseLevel !== undefined && noiseLevel !== null) {
      params.set('checkNoiseLevel', noiseLevel.toString());
    }

    return application ? `${application.url}?${params.toString()}` : '#';
  }
}
